var $ = global.jQuery = global.$;

var moment = require('moment');

var _Base = require('./_Base');
/**
 * Widget for displaying the local time. See {@link http://momentjs.com/docs/#/displaying/format/} for available date/time format combinations you can display. Default is `h:mma`
 * @class
 * @extends _Base
 * @example <div data-widget="LocalTime" data-format="HH:mm" data-timezone-offset="+4"></div>
 */
var LocalTime = _Base.extend(
  /** @lends LocalTime.prototype */
  {
  /**
   * Initialisation method
   * @private
   */
  init: function() {
    var self = this;

    this.format = this.$el.data('displayFormat') ? this.$el.data('displayFormat') : 'h:mma';
    this.offset = this.$el.data('timezoneOffset');

    this.updateTime();

    // If this is first load we set a timeout of the number of milliseconds to the next whole minute, and then run the update again. And run the interval method to update the time then every 60 seconds
    setTimeout(function() {
      self.runInterval();
      self.updateTime();
    }, this.getMillisecondsToWholeMinute());

  },
  /**
   * Get the number of milliseconds to the next whole minute
   * @returns {number} The number of milliseconds to the next whole minute
   */
  getMillisecondsToWholeMinute: function() {
    var currentUTC = moment.utc();
    return 60 * 1000 - (currentUTC.seconds() * 1000 + currentUTC.milliseconds()) + 100;
  },
  /**
   * Update the time. This is based on the `data-format` and `data-timezone-offset` attributes
   */
  updateTime: function() {
    var self = this;
    var currentUTC = moment.utc();

    this.$el.text(currentUTC.utcOffset(this.offset).format(this.format));
  },
  /**
   * Run the interval to update the time every 60 seconds
   * @private
   */
  runInterval: function() {
    var self = this;
    setInterval(function() {
      self.updateTime();
    }, 1000 * 60);
  }
});

module.exports = LocalTime;



/*****************
 ** WEBPACK FOOTER
 ** ./source/scripts/widgets/LocalTime.js
 ** module id = 47
 ** module chunks = 0 1
 **/